import { SyncStatusIndicator } from "@/components/ui/sync-status-indicator";
import { useSync } from "@/contexts/SyncContext";
import { IS_STAGING } from "@/integrations/supabase/client";

export function AppHeader() {
  const { status, triggerGlobalRefresh, isRefreshing } = useSync();

  return (
    <div className="flex items-center gap-sm">
      {import.meta.env.DEV && (
        <span
          className="text-body-sm font-medium px-md py-1 rounded-md border border-border bg-muted/80 backdrop-blur-sm"
          title={`Supabase: ${IS_STAGING ? "Staging (herycmblynigliyjlctx)" : "Production (qhibjyuubkfscpdgqszg)"}`}
        >
          {IS_STAGING ? "Staging" : "Production"}
        </span>
      )}
      <SyncStatusIndicator
        status={status}
        onRefresh={triggerGlobalRefresh}
        isRefreshing={isRefreshing}
        compact
      />
    </div>
  );
}
